type PopoverDemoItem = {
  trigger: {
    label: string;
    variant: string;
    placement: string;
    className: string;
    popoverType?: string;
  };
  header?: string;
  body:
    | string
    | Array<{
        type: 'link';
        label: string;
        href?: string;
      }>;
};

const POPOVER_DEMO_DATA: PopoverDemoItem[] = [
  {
    trigger: {
      label: 'Top Popover',
      variant: 'ghost',
      placement: 'top',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the top of the trigger.',
  },
  {
    trigger: {
      label: 'Bottom Popover',
      variant: 'ghost',
      placement: 'bottom',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the bottom of the trigger.',
  },
  {
    trigger: {
      label: 'Left Popover',
      variant: 'ghost',
      placement: 'left',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the left of the trigger.',
  },
  {
    trigger: {
      label: 'Right Popover',
      variant: 'ghost',
      placement: 'right',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the right of the trigger.',
  },
  {
    trigger: {
      label: 'Top Start Popover',
      variant: 'ghost',
      placement: 'top-start',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the top-start of the trigger.',
  },
  {
    trigger: {
      label: 'Top End Popover',
      variant: 'ghost',
      placement: 'top-end',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the top-end of the trigger.',
  },
  {
    trigger: {
      label: 'Bottom Start Popover',
      variant: 'ghost',
      placement: 'bottom-start',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the bottom-start of the trigger.',
  },
  {
    trigger: {
      label: 'Bottom End Popover',
      variant: 'ghost',
      placement: 'bottom-end',
      className: 'btn-ghost',
    },
    body: 'Popovers are anchored, dismissible panels for light interactions. This one anchors to the bottom-end of the trigger.',
  },
];

export { POPOVER_DEMO_DATA };
